var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExpandFullscreen',{staticClass:"chart-modal",attrs:{"fixed-orientation":"","available-orientations":['landscape-primary'],"start-orientation":"landscape-primary"}},[_c('DashboardFilters'),_c('DashboardChart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }